import {Component, EventEmitter, Input, OnInit, Output, ViewChildren, AfterViewInit} from '@angular/core';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit, AfterViewInit {
    @ViewChildren('input') vc;

    constructor() { }

    @Input() x = 0;
    @Input() y = 0;
    @Input() acceptText = '';
    @Input() cancelText = '';
    @Input() title: string;
    @Input() textRows: string[] = [];
    @Output() buttonEvent = new EventEmitter<string>();

    ngOnInit() {
    }

    ngAfterViewInit() {
        setTimeout(() => { this.vc.first.nativeElement.focus(); });
    }

    acceptClicked() {
        this.buttonEvent.emit('Accept');
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/dialog/dialog.component.ts